document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__sku').forEach(function(el){
    var text = (el.textContent || '').trim();
    
    if (text.toLowerCase().startsWith('artikelnr')) {
    
      el.textContent = text.replace(/^artikelnr[:.\s]*/i, '');
    }
  });
});

// truncate SEO Text Collections & vor #gf-controls-container verschieben
document.addEventListener("DOMContentLoaded", function () {
  const containerWrapper = document.querySelector(".title_seo_text");              
  if (!containerWrapper) return;
  containerWrapper.style.visibility = "hidden";

  const container = containerWrapper.querySelector(".title_seo_text_content");   
  if (!container) return;

  const WORD_LIMIT = 20;
  const moreLabel = "… mehr anzeigen";
  const lessLabel = "weniger anzeigen";

  const originalHTML = container.innerHTML.trim();
  const text = container.textContent.trim().replace(/\s+/g, " ");
  const words = text.split(" ");

  if (words.length > WORD_LIMIT) {
    const teaserText = words.slice(0, WORD_LIMIT).join(" ");
    container.innerHTML = `
      <span class="seo-teaser">${teaserText}</span>
      <span class="seo-full" style="display:none;">${originalHTML}</span>
      <a href="#" class="seo-toggle-more">${moreLabel}</a>
      <a href="#" class="seo-toggle-less" style="display:none;">${lessLabel}</a>
    `;

    const teaser = container.querySelector(".seo-teaser");
    const full   = container.querySelector(".seo-full");
    const more   = container.querySelector(".seo-toggle-more");
    const less   = container.querySelector(".seo-toggle-less");

    more.addEventListener("click", function (e) {
      e.preventDefault();
      teaser.style.display = "none";
      full.style.display = "inline";
      more.style.display = "none";
      less.style.display = "inline";
    });

    less.addEventListener("click", function (e) {
      e.preventDefault();
      teaser.style.display = "inline";
      full.style.display = "none";
      more.style.display = "inline";
      less.style.display = "none";
      containerWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function placeAndShow() {
    const target = document.querySelector("#gf-controls-container");
    if (!target) return false;

    if (target.previousElementSibling !== containerWrapper) {
      target.parentNode.insertBefore(containerWrapper, target);
    }
    containerWrapper.style.visibility = "visible";
    return true;
  }

  if (placeAndShow()) return;

  const observer = new MutationObserver(() => {
    if (placeAndShow()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// End 

/** document.addEventListener("DOMContentLoaded", function () {
  const seo = document.querySelector(".seo");

  if (!seo) return;

  const toggleBtn = document.createElement("div");
  toggleBtn.className = "show_more";
  toggleBtn.textContent = "mehr erfahren";
  toggleBtn.style.cursor = "pointer";
  toggleBtn.style.marginTop = "10px";

  seo.insertAdjacentElement("afterend", toggleBtn);

  const collapsedHeight = 400;
  let expandedHeight;

  let expanded = false;

  toggleBtn.addEventListener("click", function () {
    if (!expanded) {
      seo.style.height = "auto";
      expandedHeight = seo.scrollHeight;
      seo.style.height = collapsedHeight + "px";
      void seo.offsetWidth;

      seo.style.height = expandedHeight + "px";
      seo.classList.add("show_seo");
      toggleBtn.textContent = "wieder schließen";
    } else {
      seo.style.height = seo.scrollHeight + "px"; 
      void seo.offsetWidth;
      seo.style.height = collapsedHeight + "px";
      seo.classList.remove("show_seo");
      toggleBtn.textContent = "mehr erfahren";
    }

    expanded = !expanded;
  });

  seo.addEventListener("transitionend", function () {
    if (expanded) {
      seo.style.height = "auto";
    }
  });
});
*/


/***************************** Accordeon for Descriptions  ************************/

(function() {
  function initAccordion(container) {
    if (!container || container.dataset.accordionInit === '1') return;
    container.dataset.accordionInit = '1';

    const all = Array.from(container.children);
    const sections = [];
    let current = null;

    all.forEach((el) => {
      if (el.tagName === 'H2') {
        current = { heading: el, content: [] };
        sections.push(current);
      } else if (current) {
        current.content.push(el);
      }
    });

    if (!sections.length) return; 

    sections.forEach((section, index) => {
      const { heading, content } = section;

      if (!heading.querySelector('.accordion-caret')) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewBox", "0 0 512 512");
        svg.setAttribute("class", "accordion-caret");
        svg.innerHTML = '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M112 184l144 144 144-144" stroke-width="48"/>';
        heading.appendChild(svg);
      }

      heading.classList.add('accordion-header');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.style.cursor = 'pointer';

      let wrapper = heading.nextElementSibling;
      const needsWrapper = !(wrapper && wrapper.classList.contains('accordeon_wrapper'));
      if (needsWrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'accordeon_wrapper';
        content.forEach(el => wrapper.appendChild(el));
        heading.insertAdjacentElement('afterend', wrapper);
      }

      wrapper.style.transition = 'max-height 0.3s ease';
      wrapper.style.overflow = 'hidden';
      wrapper.style.margin = '0px';

      const caret = heading.querySelector('.accordion-caret');
      const initiallyOpen = false;
      wrapper.style.maxHeight = initiallyOpen ? wrapper.scrollHeight + 'px' : '0px';
      heading.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');
      if (initiallyOpen) caret.classList.add('rotated'); else caret.classList.remove('rotated');

      if (!heading.dataset.accordionBound) {
        const toggle = () => {
          const isOpen = heading.getAttribute('aria-expanded') === 'true';
          const nextOpen = !isOpen;

          heading.setAttribute('aria-expanded', String(nextOpen));
          if (nextOpen) {
            caret.classList.add('rotated');
            wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
            wrapper.style.overflow = 'hidden';

            setTimeout(() => {
              const offset = 250;
              const y = heading.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }, 300);
          } else {
            caret.classList.remove('rotated');
            wrapper.style.maxHeight = '0px';
          }
        };

        heading.addEventListener('click', toggle);
        heading.addEventListener('keydown', (ev) => {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            toggle();
          }
        });

        heading.dataset.accordionBound = '1';
      }
    });
  }

  function initFaqAccordion(container) {
    if (!container || container.dataset.faqAccordionInit === '1') return;
    container.dataset.faqAccordionInit = '1';

    const all = Array.from(container.children);
    const sections = [];
    let current = null;

    all.forEach((el) => {
      if (el.tagName === 'H3') {
        current = { heading: el, content: [] };
        sections.push(current);
      } else if (current) {
        current.content.push(el);
      }
    });

    if (!sections.length) return;

    sections.forEach((section, index) => {
      const { heading, content } = section;

      if (!heading.querySelector('.accordion-caret')) {
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("viewBox", "0 0 512 512");
        svg.setAttribute("class", "accordion-caret");
        svg.innerHTML = '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M112 184l144 144 144-144" stroke-width="48"/>';
        heading.appendChild(svg);
      }

      heading.classList.add('accordion-header');
      heading.setAttribute('role', 'button');
      heading.setAttribute('tabindex', '0');
      heading.style.cursor = 'pointer';

      let wrapper = heading.nextElementSibling;
      const needsWrapper = !(wrapper && wrapper.classList.contains('accordeon_wrapper'));
      if (needsWrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'accordeon_wrapper';
        content.forEach(el => wrapper.appendChild(el));
        heading.insertAdjacentElement('afterend', wrapper);
      }

      wrapper.style.transition = 'max-height 0.3s ease';
      wrapper.style.overflow = 'hidden';
      wrapper.style.margin = '0px';

      const caret = heading.querySelector('.accordion-caret');
      const initiallyOpen = false;
      wrapper.style.maxHeight = initiallyOpen ? wrapper.scrollHeight + 'px' : '0px';
      heading.setAttribute('aria-expanded', initiallyOpen ? 'true' : 'false');
      if (initiallyOpen) caret.classList.add('rotated'); else caret.classList.remove('rotated');

      if (!heading.dataset.accordionBound) {
        const toggle = () => {
          const isOpen = heading.getAttribute('aria-expanded') === 'true';
          const nextOpen = !isOpen;

          heading.setAttribute('aria-expanded', String(nextOpen));
          if (nextOpen) {
            caret.classList.add('rotated');
            wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
            wrapper.style.overflow = 'hidden';

            setTimeout(() => {
              const offset = 250;
              const y = heading.getBoundingClientRect().top + window.pageYOffset - offset;
              window.scrollTo({ top: y, behavior: 'smooth' });
            }, 300);
          } else {
            caret.classList.remove('rotated');
            wrapper.style.maxHeight = '0px';
          }
        };

        heading.addEventListener('click', toggle);
        heading.addEventListener('keydown', (ev) => {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            toggle();
          }
        });

        heading.dataset.accordionBound = '1';
      }
    });
  }

  window.initProductDescriptionAccordion = function(root = document) {
    root.querySelectorAll('.content-truncator__content').forEach(initAccordion);
  };

  window.initCollectionFaqAccordion = function(root = document) {
    root.querySelectorAll('#faq .metafield-rich_text_field').forEach(initFaqAccordion);
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.initProductDescriptionAccordion(document);
    window.initCollectionFaqAccordion(document);
  });

  document.addEventListener('product:description:ready', (e) => {
    const root = (e.detail && e.detail.root) ? e.detail.root : document;
    window.initProductDescriptionAccordion(root.ownerDocument || document);
    window.initCollectionFaqAccordion(document);
  });

  const mo = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.('.content-truncator__content')) {
          window.initProductDescriptionAccordion(node.parentNode || document);
        } else {
          const el = node.querySelector?.('.content-truncator__content');
          if (el) window.initProductDescriptionAccordion(node);
        }

        if (node.matches?.('#faq')) {
          window.initCollectionFaqAccordion(document);
        } else {
          const faq = node.querySelector?.('#faq');
          if (faq) window.initCollectionFaqAccordion(document);
        }
      });
    });
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/***************************** Accordeon for Descriptions End  ************************/ 


/* document.addEventListener('change', function (event) {
  const target = event.target;
  if (target && target.matches('input[name="attributes[Dieses Produkt auf Rezept bestellen]"]')) {
      const recipeSection = document.getElementById('product-recipe');
    if (!recipeSection) return; // Falls Section nicht existiert
    if (target.value === 'Yes') {
            recipeSection.classList.add('open');
          } else {
            recipeSection.classList.remove('open');
          }
  }
    });*/





/****************** Receipe open/close *******************/

let productAvailable = null;

const observer = new MutationObserver(() => {

  /***************** Produktverfügbarkeit prüfen *****************/

  if (productAvailable === null) {
    const variantsJson = document.querySelector('[data-product-variants]');

    if (variantsJson) {
      try {
        const variants = JSON.parse(variantsJson.textContent);
        productAvailable = variants.some(variant => variant.available);
      } catch (e) {
        console.warn('Produktvarianten konnten nicht gelesen werden', e);
        return;
      }
    } else {
     
      const juoData = document.querySelector('#juo-subscription-widget-data');

      if (juoData) {
        try {
          const data = JSON.parse(juoData.textContent);
          const variants = Array.isArray(data?.[0]) ? data[0] : [];

          productAvailable = variants.length
            ? variants.some(variant => variant.available !== false)
            : true;

        } catch (e) {
          productAvailable = true;
        }
      } else {
        if (!document.querySelector('#juo-subscription-widget')) return;
        productAvailable = true;
      }
    }
  }


  /***************** Kein Bestand → Abo ausblenden *****************/

  if (!productAvailable) {
    const subscriptionBlocks = document.querySelectorAll(
      '[id*="juo_subscriptions"]'
    );

    if (!subscriptionBlocks.length) return;

    subscriptionBlocks.forEach(block => {
      block.style.display = 'none';
    });

    observer.disconnect();
    return;
  }


  /***************** Abo initialisieren *****************/

  const widget = document.querySelector('#juo-subscription-widget');

  if (!widget) return;

  const subscriptionRadio = widget.querySelector(
    'input[type="radio"][value="subscription"]'
  );

  const otpRadio = widget.querySelector(
    'input[type="radio"][value="otp"]'
  );

  const sellingPlanSelect = widget.querySelector(
    'select[data-ref="selling-plan"]'
  );

  const wrapper = widget.querySelector(
    '.j-subscription-wrapper'
  );

  const subscriptionLabel = widget.querySelector(
    '.j-subscription > .j-label'
  );

  if (
    !subscriptionRadio ||
    !otpRadio ||
    !wrapper ||
    !subscriptionLabel
  ) {
    return;
  }

  if (subscriptionRadio.dataset.customToggleInit === '1') {
    observer.disconnect();
    return;
  }

  subscriptionRadio.dataset.customToggleInit = '1';


  /***************** selling_plan entfernen *****************/

  function clearSellingPlanInputs() {
    document.querySelectorAll(
      'input[name="selling_plan"]'
    ).forEach(input => {
      input.value = '';
      input.removeAttribute('value');
    });
  }


  /***************** Zustand spiegeln *****************/

  function syncSubscriptionState() {

    const active =
      subscriptionRadio.checked &&
      !otpRadio.checked;

    subscriptionRadio.dataset.active =
      active ? 'true' : 'false';

    wrapper.classList.toggle(
      'open',
      active
    );

    if (!active && otpRadio.checked) {
      clearSellingPlanInputs();
    }
  }


  /***************** Zustand VOR dem Klick merken *****************/

  let subscriptionWasActive = false;

  subscriptionLabel.addEventListener(
    'pointerdown',
    () => {

      subscriptionWasActive =
        subscriptionRadio.dataset.active === 'true' ||
        (
          subscriptionRadio.checked &&
          !otpRadio.checked
        );

    },
    true
  );


  /***************** Sparabo an-/abwählen *****************/

  subscriptionLabel.addEventListener(
    'click',
    (e) => {

      if (!subscriptionWasActive) {

        setTimeout(
          syncSubscriptionState,
          0
        );

        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();


      setTimeout(() => {
        otpRadio.click();

        subscriptionRadio.dataset.active = 'false';

        wrapper.classList.remove('open');
        clearSellingPlanInputs();

        requestAnimationFrame(
          clearSellingPlanInputs
        );

        setTimeout(
          clearSellingPlanInputs,
          50
        );

        subscriptionWasActive = false;

      }, 0);

    },
    true
  );


  /***************** Juo-Änderungen beobachten *****************/

  subscriptionRadio.addEventListener(
    'change',
    () => {
      setTimeout(
        syncSubscriptionState,
        0
      );
    }
  );


  otpRadio.addEventListener(
    'change',
    () => {
      setTimeout(
        syncSubscriptionState,
        0
      );
    }
  );


  /***************** Lieferintervall *****************/

  if (sellingPlanSelect) {

    ['click', 'change'].forEach(ev => {

      sellingPlanSelect.addEventListener(
        ev,
        () => {

          subscriptionRadio.dataset.active = 'true';

          wrapper.classList.add('open');

          setTimeout(
            syncSubscriptionState,
            0
          );

        }
      );

    });

  }

  setTimeout(
    syncSubscriptionState,
    50
  );


  observer.disconnect();
});


observer.observe(
  document.body,
  {
    childList: true,
    subtree: true
  }
);

/****************** Receipe open/close end *******************/



/****************** Rezept open/close *******************/

document.addEventListener(
  'click',
  (e) => {

    const yesRadio = e.target.closest(
      'input[type="radio"][value="Yes"]'
    );

    const noRadio = document.querySelector(
      'input[type="radio"][value="No"]'
    );

    const section = document.getElementById(
      'product-recipe'
    );

    if (!yesRadio || !section) return;


    const active = section.classList.toggle(
      'open'
    );

    yesRadio.checked = active;


    if (noRadio) {
      noRadio.checked = !active;
    }

  }
);

/****************** Rezept open/close end *******************/



/****************** Gegenseitiges Ausschließen *******************/

document.addEventListener(
  'change',
  (e) => {

    const target = e.target;

    const widget = document.querySelector(
      '#juo-subscription-widget'
    );

    const subscriptionRadio = widget?.querySelector(
      'input[type="radio"][value="subscription"]'
    );

    const otpRadio = widget?.querySelector(
      'input[type="radio"][value="otp"]'
    );

    const yesRadio = document.querySelector(
      'input[type="radio"][value="Yes"]'
    );

    const noRadio = document.querySelector(
      'input[type="radio"][value="No"]'
    );


    /***************** Abo / Einmalkauf → Rezept schließen *****************/

    if (
      target === subscriptionRadio ||
      target === otpRadio
    ) {

      if (yesRadio) {
        yesRadio.checked = false;
      }

      if (noRadio) {
        noRadio.checked = true;
      }

      const recipeSection = document.getElementById(
        'product-recipe'
      );

      if (recipeSection) {
        recipeSection.classList.remove(
          'open'
        );
      }
    }


    /***************** Rezept → Abo ausschalten *****************/

    if (
      target === yesRadio ||
      target === noRadio
    ) {

      if (subscriptionRadio) {
        subscriptionRadio.checked = false;
        subscriptionRadio.dataset.active = 'false';
      }

      if (otpRadio) {
        otpRadio.click();
      }

      document.querySelectorAll(
        'input[name="selling_plan"]'
      ).forEach(input => {
        input.value = '';
        input.removeAttribute('value');
      });


      const subWrapper = widget?.querySelector(
        '.j-subscription-wrapper'
      );

      if (subWrapper) {
        subWrapper.classList.remove(
          'open'
        );
      }
    }

  }
);

/****************** Gegenseitiges Ausschließen end *******************/


function get_product_info() {
  const localKey = 'trusted_shop';

  const alreadyExecuted = localStorage.getItem(localKey) === '1';
  const currentVariantSku = document.querySelector('.product__sku')?.textContent?.trim() || null;

  function getMainProductSku() {
    try {
      const p = window.ShopifyAnalytics?.meta?.product;
      if (p?.sku && typeof p.sku === 'string' && p.sku.trim()) return p.sku.trim();
      if (p?.id && typeof p.id === 'number') return String(p.id); // Fallback: ID als "Haupt-SKU"
    } catch (_) {}

    try {
      const ldJsonNodes = Array.from(document.querySelectorAll('script[type="application/ld+json"]'));
      for (const n of ldJsonNodes) {
        const data = JSON.parse(n.textContent || 'null');
        const list = Array.isArray(data) ? data : [data];
        for (const entry of list) {
          const type = entry && entry['@type'];
          const isProduct = type === 'Product' || (Array.isArray(type) && type.includes('Product'));
          if (isProduct && entry.sku && typeof entry.sku === 'string') {
            return entry.sku.trim();
          }
        }
      }
    } catch (_) {}

    const byDataAttr = document.querySelector('[data-main-sku]')?.getAttribute('data-main-sku')?.trim();
    if (byDataAttr) return byDataAttr;

    const byMeta = document.querySelector('meta[name="main-sku"]')?.getAttribute('content')?.trim();
    if (byMeta) return byMeta;

    if (typeof window.__MAIN_SKU__ === 'string' && window.__MAIN_SKU__.trim()) {
      return window.__MAIN_SKU__.trim();
    }

    return null;
  }

  /*************** Etrust Anzeige vereinheitlichen *******************/
  function getAllVariantSkus() {
    const skus = new Set();

    try {
      const variants = window.ShopifyAnalytics?.meta?.product?.variants;
      if (Array.isArray(variants)) {
        variants.forEach(v => {
          const sku = (v?.sku ?? '').trim?.() || '';
          if (sku) skus.add(sku);
        });
      }
    } catch (_) {}

    document.querySelectorAll('[data-variant-sku]').forEach(el => {
      const sku = el.getAttribute('data-variant-sku')?.trim();
      if (sku) skus.add(sku);
    });


    try {
      const jsonScripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
      for (const s of jsonScripts) {
        const txt = s.textContent || '';
        if (!/\"variants\"\s*:/i.test(txt)) continue;
        const obj = JSON.parse(txt);
        const variants = obj?.variants;
        if (Array.isArray(variants)) {
          variants.forEach(v => {
            const sku = (v?.sku ?? '').toString().trim();
            if (sku) skus.add(sku);
          });
        }
      }
    } catch (_) {}

  
    if (currentVariantSku) skus.add(currentVariantSku);

    return Array.from(skus);
  }

  const mainProductSku = getMainProductSku();
  const allVariantSkus = getAllVariantSkus();
  const combinedSkus = Array.from(new Set([mainProductSku, ...allVariantSkus].filter(Boolean))).join(',');

  const widgetHTML = (id) => `
    <etrusted-widget 
      data-etrusted-widget-id="${id}"
      data-sku="${combinedSkus}">
    </etrusted-widget>`;

  if (!alreadyExecuted) {
    if (typeof get_json_for_product_details === 'function') {
      get_json_for_product_details(currentVariantSku);
    }

    // Obere Sterne-Anzeige
    const reviewStars = document.querySelector('#reviewstars');
    if (reviewStars) {
      reviewStars.innerHTML = widgetHTML('wdg-5fca2fb9-5ca9-4276-9dbf-d6701a36cfce');
    }

    const skuLabel = document.querySelector('.product__sku');
    if (skuLabel && currentVariantSku) {
      skuLabel.textContent = `Artikelnr: ${currentVariantSku}`;
    }

  const reviewContainer = document.querySelector('#shopify-section-trusted-shop_js');
  if (reviewContainer) {
      reviewContainer.innerHTML = ''; 
    const reviewWidget = document.createElement('div');
    reviewWidget.innerHTML = widgetHTML('wdg-1d65b860-cc84-40b8-b180-00671027a888');
    reviewContainer.appendChild(reviewWidget);
  }

    // eTrusted Script
    const script = document.createElement('script');
    script.src = 'https://integrations.etrusted.com/applications/widget.js/v2';
    script.type = 'text/javascript';
    script.async = true;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    localStorage.setItem(localKey, '1');
    setTimeout(() => {
      localStorage.setItem(localKey, '0');
    }, 1000);
  } else {
    if (typeof get_json_for_product_details === 'function') {
      get_json_for_product_details(currentVariantSku);
    }
  }
  window.eTrustedCombinedSkus = combinedSkus;
}
get_product_info();

document.addEventListener('DOMContentLoaded', () => {

  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.tagName?.toLowerCase() === 'quick-add-modal' || node.querySelector?.('quick-add-modal')) {
            const modal = node.tagName?.toLowerCase() === 'quick-add-modal' ? node : node.querySelector('quick-add-modal');
            if (modal) {
              console.log('modal gefunden');

              modal.querySelectorAll('.j-custom-select').forEach(wrapper => wrapper.remove());
              const modalObserver = new MutationObserver((attrMutations) => {
                attrMutations.forEach(attrMutation => {
                  if (
                    attrMutation.type === 'attributes' &&
                    attrMutation.attributeName === 'open' &&
                    modal.hasAttribute('open')
                  ) {
                    //console.log('modal open erkannt');

                  
                    if (window.eTrustedCombinedSkus) {
                      console.log('→ Gesamtbewertung aus globalem SKU-Cache wird ins Modal geladen');
                      renderTrustedWidgetInModal(window.eTrustedCombinedSkus, modal);
                    } else if (typeof get_product_info === 'function') {
                      console.log('→ kein SKU-Cache vorhanden → get_product_info() Fallback');
                      get_product_info();
                    }
                  }
                });
              });

              modalObserver.observe(modal, { attributes: true });

              bodyObserver.disconnect(); 
            }
          }
        }
      }
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
});



function renderTrustedWidgetInModal(combinedSkus, modal) {
  const container = modal.querySelector('#shopify-section-trusted-shop_js');
  if (!container) return;

  container.innerHTML = '';
  const div = document.createElement('div');
  div.innerHTML = `
    <etrusted-widget 
      data-etrusted-widget-id="wdg-1d65b860-cc84-40b8-b180-00671027a888"
      data-sku="${combinedSkus}">
    </etrusted-widget>`;
  container.appendChild(div);

  if (!document.querySelector('script[src*="etrusted.com/applications/widget.js"]')) {
    const script = document.createElement('script');
    script.src = 'https://integrations.etrusted.com/applications/widget.js/v2';
    script.async = true;
    document.body.appendChild(script);
  } else if (window._etrusted?.initWidgets) {
    // Script ist bereits da → Widget neu initialisieren
    window._etrusted.initWidgets(container);
  }
}



/*************** Etrust Anzeige vereinheitlichen End *******************/



function get_product_json() {
    $.getJSON('https://liveocare.myshopify.com/products.json', function(product) {
    });
  }


/************** Pfad bei Collection-Cards neu setzen *************/

(function () {
  const selector = 'a[href*="/products/"]';

  function getCollectionHandle() {
    const m = location.pathname.match(/\/collections\/([^/]+)/);
    return m ? m[1] : null;
  }

  function toCollectionUrl(href, collection) {
    if (!href || !collection) return null;

    const url = new URL(href, location.origin);

    if (url.pathname.includes('/collections/')) {
      return url.toString();
    }

    const parts = url.pathname.split('/').filter(Boolean);
    const productHandle = parts.pop();

    if (!productHandle) return null;

    url.pathname = `/collections/${collection}/products/${productHandle}`;

    return url.toString();
  }

  function rewriteSingleLink(a, collection) {
    if (!a || !collection) return;

    const origHrefAttr = a.getAttribute('href');
    const target = toCollectionUrl(origHrefAttr, collection);

    if (!target) return;

    if (!origHrefAttr || !origHrefAttr.includes('/collections/')) {
      a.setAttribute('href', target.replace(location.origin, ''));
      a.href = target;
    }
  }

  function rewriteProductLinks(root) {
    const collection = getCollectionHandle();

    if (!collection) return;

    const context = root && typeof root.querySelectorAll === 'function' ? root : document;

    if (context.matches && context.matches(selector)) {
      rewriteSingleLink(context, collection);
    }

    context.querySelectorAll(selector).forEach((a) => {
      rewriteSingleLink(a, collection);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    rewriteProductLinks(document);
  });

  document.addEventListener('spf:render', function () {
    rewriteProductLinks(document);
  });

  const mo = new MutationObserver((mutations) => {
    const collection = getCollectionHandle();

    if (!collection) return;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!node || node.nodeType !== 1) return;

        rewriteProductLinks(node);
      });
    });
  });

  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target.closest(selector);

      if (!a) return;

      const collection = getCollectionHandle();

      if (!collection) return;

      const newUrl = toCollectionUrl(a.getAttribute('href'), collection);

      if (newUrl && a.href !== newUrl) {
        e.preventDefault();
        location.href = newUrl;
      }
    },
    true
  );
})();

/************** Pfad bei Collection-Cards neu setzen End *************/

/************** Product remove highlights + Modal Support ********************/
document.addEventListener('DOMContentLoaded', function () {
  initProductFormFeatures(document);

  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        const modal =
          node.tagName?.toLowerCase() === 'quick-add-modal'
            ? node
            : node.querySelector?.('quick-add-modal');

        if (modal && !modal.dataset.initObserver) {
          modal.dataset.initObserver = '1'; 

          const modalObserver = new MutationObserver(attrMutations => {
            attrMutations.forEach(attrMutation => {
              if (
                attrMutation.type === 'attributes' &&
                attrMutation.attributeName === 'open' &&
                modal.hasAttribute('open')
              ) {
                console.log('🟦 Modal geöffnet → Produktformular initialisieren');
                initProductFormFeatures(modal);
              }
            });
          });

          modalObserver.observe(modal, { attributes: true });
        }
      }
    }
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
});

function initProductFormFeatures(root) {
  root.querySelectorAll('.product-form__input label').forEach(el => {
    el.classList.add('no_highlight');
  });

  function disableButtonIfPillExists() {
    const pill = root.querySelector('.product-form__input--pill'); 
    if (pill) {
      const btn = root.querySelector('.product-form__submit');
      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-disabled');
      }
      return true;
    }
    return false;
  }

  if (!disableButtonIfPillExists()) {
    const observer = new MutationObserver(() => {
      if (disableButtonIfPillExists()) {
        observer.disconnect();
      }
    });
    observer.observe(root, { childList: true, subtree: true }); 
  }

  const enableForm = () => {
    root.querySelectorAll('.no_highlight').forEach(el => el.classList.remove('no_highlight'));
    const submitBtn = root.querySelector('.product-form__submit');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-disabled');
    }
  };

  root.addEventListener('click', function (e) {
    const target = e.target.closest('.no_highlight');
    if (target) {
      enableForm();
    }
  });

  const overlay = root.querySelector('.product-form__buttons');
  const tooltip = root.querySelector('.button-tooltip');
  const submitBtn = root.querySelector('.product-form__submit'); 

  if (overlay && tooltip && submitBtn) {
    overlay.addEventListener('click', function (e) {
      if (submitBtn.disabled || submitBtn.classList.contains('is-disabled')) {
        e.preventDefault();
        tooltip.classList.add('visible');
        setTimeout(() => tooltip.classList.remove('visible'), 2000);
      }
    });
  }
}


/**** Recommendations responsiv verschieben (<= 749px hinters Panel, > 749px zurück) ****/

(function () {
  let recommendationsEl = null;
  let placeholder = null;         
  let listenersAttached = false;

  const mql = window.matchMedia('(max-width: 749px)');

  function ensureElements() {
    if (!recommendationsEl) {
      recommendationsEl = document.querySelector('product-recommendations');
      if (!recommendationsEl) return false;
    }
    const sourceContainer = recommendationsEl.closest('.product__info-container');
    if (!sourceContainer) return false;

    if (!placeholder) {
      placeholder = document.createComment('recommendations-placeholder');
      sourceContainer.parentNode.insertBefore(placeholder, sourceContainer);
    }
    return true;
  }

  function moveToMobile() {
    const sourceContainer = recommendationsEl.closest('.product__info-container');
    const targetPanel = document.querySelector('section.product__media-submedia-wrapper .product__info-panel');
    if (!sourceContainer || !targetPanel) return;

    if (targetPanel.nextElementSibling !== sourceContainer) {
      targetPanel.insertAdjacentElement('afterend', sourceContainer);
    }
  }

  function moveToDesktop() {
    const sourceContainer = recommendationsEl.closest('.product__info-container');
    if (!sourceContainer || !placeholder || !placeholder.parentNode) return;

    if (sourceContainer.previousSibling !== placeholder) {
      placeholder.parentNode.insertBefore(sourceContainer, placeholder);
    }
  }

  function applyLayout() {
    if (!ensureElements()) return;
    if (mql.matches) {
      // <= 749px
      moveToMobile();
    } else {
      // > 749px
      moveToDesktop();
    }
  }

  function attachListenersOnce() {
    if (listenersAttached) return;
    listenersAttached = true;

    if (mql.addEventListener) {
      mql.addEventListener('change', applyLayout);
    } else if (mql.addListener) {
      mql.addListener(applyLayout);
    }
    window.addEventListener('resize', applyLayout);
  }

  function initIfReady() {
    if (!document.body) return;
    if (!document.querySelector('product-recommendations')) return;
    ensureElements();
    applyLayout();
    attachListenersOnce();
  }

  document.addEventListener('DOMContentLoaded', initIfReady);
  const mo = new MutationObserver(() => {
    if (!recommendationsEl && document.querySelector('product-recommendations')) {
      initIfReady();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


/************** Text hinter - bold  ***********************/

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-header').forEach(header => {
    const svg = header.querySelector('svg');

    // gesamten Textinhalt des Headers holen,
    // aber ohne den SVG-Text
    const full = header.cloneNode(true);
    const svgInClone = full.querySelector('svg');
    if (svgInClone) svgInClone.remove();

    const text = full.textContent
      .replace(/\u00A0/g, ' ')   // NBSP entfernen
      .replace(/\s+/g, ' ')
      .trim();

    const parts = text.split(/\s*[-–—]\s*/);

    // neuen Inhalt generieren
    const span = document.createElement('span');
    if (parts.length >= 2) {
      span.innerHTML = `${parts[0]} - <strong>${parts.slice(1).join(' - ')}</strong>`;
    } else {
      span.textContent = text;
    }

    // alten Inhalt löschen
    header.innerHTML = '';
    header.appendChild(span);

    // SVG wieder anhängen
    if (svg) header.appendChild(svg);
  });
});


/***** Varianten Auswahl mit Re-Entrancy Schutz und Cooldown – angepasst *****/
function initVariantObserver(container) {
  if (!container || container.dataset.variantObserverInit === '1') return;
  container.dataset.variantObserverInit = '1';

  let timeoutId;
  let autoSelecting = false;
  let suppressUntil = 0;
  let observer;

  const isInModal = container.closest('.quick-add-modal') !== null;

  if (isInModal) {
    container.addEventListener('click', (e) => {
      if (e.target.matches('input[type="radio"]')) {
        suppressUntil = Date.now() + 500;
      }
    });
  }

  const maybeActivateObserver = () => {
    const sets = container.querySelectorAll('fieldset');
    const count = sets.length;

    if (count < 2) {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      return;
    }

    if (!observer) {
      observer = new MutationObserver(() => {
        if (isInModal && Date.now() < suppressUntil) return;
        if (autoSelecting) return;

        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          const sets = container.querySelectorAll('fieldset');
          if (sets.length < 2) return;

          const secondFieldset = sets[1];
          const availableOptions = secondFieldset.querySelectorAll(
            'input[type="radio"]:not(.disabled):not([disabled])'
          );
          if (!availableOptions.length) return;

          const checked = secondFieldset.querySelector('input[type="radio"]:checked');
          const isValidChecked =
            checked && !checked.classList.contains('disabled') && !checked.disabled;

          // ✨ NEU: Wenn aktuelle Auswahl "sold_out" ist, keine Auto-Selection!
          if (checked && checked.getAttribute('mode') === 'not_available') return;

          // ✨ Nur "not_exist" Varianten triggern Auto-Auswahl
          const checkedMode = checked ? checked.getAttribute('mode') : null;
          if (checkedMode === 'not_exist' || !isValidChecked) {
            const firstAvailable = availableOptions[0];
            if (firstAvailable) {
              console.log('✨ Auto-Selection:', firstAvailable.value);
              autoSelecting = true;
              firstAvailable.click();
              setTimeout(() => { autoSelecting = false; }, 200);
            }
          }
        }, 150);
      });

      observer.observe(container, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['id', 'form', 'class', 'disabled', 'checked', 'mode']
      });
    }
  };

  maybeActivateObserver();

  const dynamicWatcher = new MutationObserver(() => {
    maybeActivateObserver();
  });
  dynamicWatcher.observe(container, { childList: true, subtree: true });
}

function initAllVariantContainers() {
  document.querySelectorAll('.product__info-container').forEach(initVariantObserver);
}

document.addEventListener('DOMContentLoaded', initAllVariantContainers);

const bodyObserver = new MutationObserver(() => {
  document.querySelectorAll('.product__info-container').forEach(initVariantObserver);
});
bodyObserver.observe(document.body, {
  subtree: true,
  childList: true
});


/****** Scroll down zu Bewertungen unten */ 

document.addEventListener('click', function (event) {
  const starWidget = event.target.closest('#etrusted-product_star');
  if (starWidget) {
    const accordions = document.querySelectorAll('.product__accordion');
    const lastAccordion = accordions[accordions.length - 1];

    if (lastAccordion) {
      const detailsEl = lastAccordion.querySelector('details');
      if (detailsEl) {
        detailsEl.open = true;

        detailsEl.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        setTimeout(() => {
          window.scrollBy({
            top: -100,
            behavior: 'smooth'
          });
        }, 300);

      } else {
        console.warn('Kein <details>-Element im letzten .product__accordion gefunden');
      }
    } else {
      console.warn('Kein .product__accordion gefunden');
    }
  }
});


document.addEventListener('click', function (event) {
  const stickyBtn = event.target.closest('.sticky-cta__button .button');
  if (!stickyBtn) return;

  const submitBtn = document.querySelector('.product-form__submit');
  if (!submitBtn || !submitBtn.classList.contains('is-disabled')) return;

  const container = stickyBtn.closest('.sticky-cta__button') || stickyBtn;

  const existing = container.querySelector('.button-tooltip');
  if (existing) existing.remove();

  const tooltip = document.createElement('div');
  tooltip.className = 'button-tooltip';
  tooltip.textContent = 'Bitte zuerst eine Variante auswählen';
  container.appendChild(tooltip);

  requestAnimationFrame(() => tooltip.classList.add('visible'));

  setTimeout(() => {
    tooltip.classList.remove('visible');
    setTimeout(() => tooltip.remove(), 200);
  }, 3000);
});


/********** get Productname for modal input ************/

document.addEventListener('DOMContentLoaded', () => {
  let storedProductName = '';

  function getProductName() {
    const header = document.querySelector('.product__title h1');
    console.log(header);
    return header ? header.textContent.trim() : '';
  }

  function attachTriggerListener(button) {
    if (button.dataset.listenerAttached) return;
    button.dataset.listenerAttached = 'true';

    button.addEventListener('click', () => {
      storedProductName = getProductName();
    });
  }

  const buttonObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches('.bcontact-trigger-button')) {
          attachTriggerListener(node);
        } else {
          const found = node.querySelector('.bcontact-trigger-button');
          if (found) attachTriggerListener(found);
        }
      }
    }
  });

  buttonObserver.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('.bcontact-trigger-button').forEach(attachTriggerListener);

  const modalObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        const input = node.matches('#bcontact-Produkt-516367')
          ? node
          : node.querySelector('#bcontact-Produkt-516367');
        if (input && storedProductName) {
          input.value = storedProductName;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  });

  modalObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    const submitBtn = e.target.closest('.bcontact-submit-btn');
    if (submitBtn) {
      const input = document.querySelector('#bcontact-Produkt-516367');
      if (input) {
        if (!storedProductName) storedProductName = getProductName();
        input.value = storedProductName;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));

        console.log(storedProductName);
      }
    }
  });
});

// Dropdown Ländervorwahl reduzieren

(function () {
  const allowed = ["Germany", "Austria"];

  function reduceSelect(select) {
    if (!select) return;

    Array.from(select.options).forEach(opt => {
      const txt = (opt.textContent || "").trim();
      if (opt.disabled && opt.value === "") return; 
      const ok = allowed.some(c => txt.startsWith(c + " "));
      if (!ok) opt.remove();
    });

    if (!select.value || select.selectedIndex <= 0) {
      const firstAllowed = Array.from(select.options).find(o =>
        allowed.some(c => (o.textContent || "").trim().startsWith(c + " "))
      );
      if (firstAllowed) select.value = firstAllowed.value;
    }
  }

  function findAndReduce(root = document) {
    const select = root.querySelector(
      ".bcontact_select__phone-wrapper select.bcontact_select"
    );
    if (select) reduceSelect(select);
    return select;
  }

  const domObs = new MutationObserver(muts => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        const sel = findAndReduce(node);
        if (sel) watchOptions(sel); 
      }
    }
  });
  domObs.observe(document.body, { childList: true, subtree: true });
  const initial = findAndReduce();
  if (initial) watchOptions(initial);

  function watchOptions(select) {
    if (select.dataset.watch === "1") return;
    select.dataset.watch = "1";

    const optObs = new MutationObserver(() => {
      reduceSelect(select);
    });

    optObs.observe(select, { childList: true, subtree: true });
    reduceSelect(select);
  }
})();

// Open Collapsible Row
document.addEventListener('click', function (e) {
  const link = e.target.closest('.multicolumn-card[data-link]');
  if (!link) return;

  e.preventDefault();

  const key = link.dataset.link;
  const acc = document.querySelector(
  '.collapsible-content__heading[data-target="' + key + '"], ' +
  '.accordion[data-target="' + key + '"]'
);
  if (!acc) return;

  const header = document.querySelector('.header-wrapper, header, .site-header');
  const headerH = header ? header.getBoundingClientRect().height : 0;
  const extra = 80;

  const y = acc.getBoundingClientRect().top + window.pageYOffset - headerH - extra;

  window.scrollTo({ top: y, behavior: 'smooth' });

  //const details = acc.querySelector('details');
  //if (details && !details.open) details.open = true;
});




/*document.addEventListener('click', (e) => {
  const btn = e.target.closest('.quick-add-modal__toggle');
  if (btn) {
    console.log('Modal wird geschlossen → Seite neu laden');
    window.location.reload();
  }
});*/




/********************* hide unused images in Product-Slider ***********************/

function getLastIdPart(value = '') {
  return String(value).split('-').pop();
}

function getSelectedOptions(variantSelects) {
  return Array.from(variantSelects.querySelectorAll('fieldset')).map((fieldset) => {
    const checked = fieldset.querySelector('input[type="radio"]:checked');
    return checked ? checked.value.trim() : null;
  });
}

function findCurrentVariant(variantSelects) {
  const variantsScript = variantSelects.querySelector('[data-product-variants]');
  if (!variantsScript) return null;

  let variants;
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch {
    return null;
  }

  const selectedOptions = getSelectedOptions(variantSelects);

  return variants.find((variant) =>
    selectedOptions.every((value, index) =>
      String(variant[`option${index + 1}`] || '').trim() === String(value || '').trim()
    )
  ) || null;
}

function getVisibleSlides(gallery) {
  return Array.from(gallery.querySelectorAll('.product__media-item'))
    .filter((slide) => slide.style.display !== 'none');
}

function getVisibleThumbs(gallery) {
  return Array.from(gallery.querySelectorAll('.thumbnail-list__item'))
    .filter((thumb) => thumb.style.display !== 'none');
}

function setActiveVisibleSlide(gallery, index) {
  const visibleSlides = getVisibleSlides(gallery);
  const visibleThumbs = getVisibleThumbs(gallery);
  const slider = gallery.querySelector('.product__media-list');

  if (!visibleSlides.length) return;

  const safeIndex = Math.max(0, Math.min(index, visibleSlides.length - 1));
  const activeSlide = visibleSlides[safeIndex];
  const activeThumb = visibleThumbs[safeIndex] || null;

  gallery.querySelectorAll('.product__media-item').forEach((slide) => {
    slide.classList.remove('is-active', 'is-incoming');
  });

  gallery.querySelectorAll('.thumbnail-list__item button.thumbnail').forEach((button) => {
    button.removeAttribute('aria-current');
  });

  activeSlide.classList.add('is-active');

  if (activeThumb) {
    const button = activeThumb.querySelector('button.thumbnail');
    if (button) button.setAttribute('aria-current', 'true');
  }

  if (slider) {
    slider.scrollTo({
      left: activeSlide.offsetLeft,
      behavior: 'auto'
    });
  }

  const currentCounter = gallery.querySelector('.slider-counter--current');
  const totalCounter = gallery.querySelector('.slider-counter--total');

  if (currentCounter) currentCounter.textContent = String(safeIndex + 1);
  if (totalCounter) totalCounter.textContent = String(visibleSlides.length);

  const prevButtons = gallery.querySelectorAll('.slider-button--prev');
  const nextButtons = gallery.querySelectorAll('.slider-button--next');

  prevButtons.forEach((btn) => {
    btn.disabled = safeIndex === 0;
  });

  nextButtons.forEach((btn) => {
    btn.disabled = safeIndex === visibleSlides.length - 1;
  });

  gallery.dataset.visibleIndex = String(safeIndex);
}

function updateVariantMediaGallery(variantSelects) {
  if (!variantSelects) return;

  const sectionId = variantSelects.dataset.section;
  const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
  if (!gallery) return;

  const featuredMapScript = gallery.querySelector('[data-variant-featured-media-map]');
  if (!featuredMapScript) return;

  let featuredMap;
  try {
    featuredMap = JSON.parse(featuredMapScript.textContent);
  } catch {
    return;
  }

  const currentVariant = findCurrentVariant(variantSelects);
  if (!currentVariant) return;

  const activeMediaId = String(featuredMap[String(currentVariant.id)] || '');
  if (!activeMediaId) return;

  const allVariantMediaIds = new Set(
    Object.values(featuredMap).filter(Boolean).map(String)
  );

  const slides = Array.from(gallery.querySelectorAll('.product__media-item'));
  const thumbs = Array.from(gallery.querySelectorAll('.thumbnail-list__item'));

  slides.forEach((slide) => {
    const mediaId = getLastIdPart(slide.dataset.mediaId);

    // Nur aktuelle Variantenbilder + allgemeine Bilder sichtbar lassen
    const isVariantSpecific = allVariantMediaIds.has(mediaId);
    const shouldShow = mediaId === activeMediaId || !isVariantSpecific;

    slide.style.display = shouldShow ? '' : 'none';
  });

  thumbs.forEach((thumb) => {
    const mediaId = getLastIdPart(thumb.dataset.target);

    const isVariantSpecific = allVariantMediaIds.has(mediaId);
    const shouldShow = mediaId === activeMediaId || !isVariantSpecific;

    thumb.style.display = shouldShow ? '' : 'none';
  });

  const visibleSlides = getVisibleSlides(gallery);
  const newIndex = visibleSlides.findIndex(
    (slide) => getLastIdPart(slide.dataset.mediaId) === activeMediaId
  );

  setActiveVisibleSlide(gallery, newIndex > -1 ? newIndex : 0);
}

function bindFilteredSliderNavigation() {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.slider-button');
    if (!button) return;

    const gallery = button.closest('media-gallery');
    if (!gallery) return;

    const isPrev = button.classList.contains('slider-button--prev');
    const isNext = button.classList.contains('slider-button--next');

    if (!isPrev && !isNext) return;

    event.preventDefault();
    event.stopPropagation();

    const currentIndex = parseInt(gallery.dataset.visibleIndex || '0', 10);
    const visibleSlides = getVisibleSlides(gallery);

    if (!visibleSlides.length) return;

    let nextIndex = currentIndex;

    if (isPrev) nextIndex = currentIndex - 1;
    if (isNext) nextIndex = currentIndex + 1;

    setActiveVisibleSlide(gallery, nextIndex);
  }, true);

  document.addEventListener('click', (event) => {
    const thumbButton = event.target.closest('.thumbnail-list__item button.thumbnail');
    if (!thumbButton) return;

    const gallery = thumbButton.closest('media-gallery');
    if (!gallery) return;

    const visibleThumbs = getVisibleThumbs(gallery);
    const visibleIndex = visibleThumbs.findIndex(
      (thumb) => thumb.querySelector('button.thumbnail') === thumbButton
    );

    if (visibleIndex === -1) return;

    event.preventDefault();
    event.stopPropagation();

    setActiveVisibleSlide(gallery, visibleIndex);
  }, true);
}

document.addEventListener('change', (event) => {
  const variantSelects = event.target.closest('variant-selects');
  if (!variantSelects) return;

  updateVariantMediaGallery(variantSelects);
});

document.addEventListener('DOMContentLoaded', () => {
  bindFilteredSliderNavigation();

  document.querySelectorAll('variant-selects').forEach((variantSelects) => {
    updateVariantMediaGallery(variantSelects);
  });
});

document.addEventListener('click', function (event) {
  const card = event.target.closest('.js-card-is-clickable');
  if (!card) return;

  if (event.target.closest('a, button, input, select, textarea, summary, details, [role="button"]')) {
    return;
  }

  const url = card.dataset.cardLink;
  if (!url) return;

  if (event.metaKey || event.ctrlKey) {
    window.open(url, '_blank');
    return;
  }

  window.location.href = url;
});

document.addEventListener('keydown', function (event) {
  const card = event.target.closest('.js-card-is-clickable');
  if (!card) return;

  if (event.key !== 'Enter' && event.key !== ' ') return;

  if (event.target.closest('a, button, input, select, textarea, summary, details, [role="button"]')) {
    return;
  }

  event.preventDefault();

  const url = card.dataset.cardLink;
  if (!url) return;

  window.location.href = url;
});


/********************* Hide globo-filter-field when empty ***********************/

document.addEventListener('DOMContentLoaded', function () {
  function initGloboSelectedItemsWrapper() {
    const wrapper = document.querySelector('.globo-selected-items-wrapper');

    if (!wrapper || wrapper.dataset.visibilityObserver === '1') return;

    wrapper.dataset.visibilityObserver = '1';

    function updateVisibility() {
      wrapper.style.display = wrapper.textContent.trim() === '' ? 'none' : '';
    }

    updateVisibility();

    const observer = new MutationObserver(updateVisibility);

    observer.observe(wrapper, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  initGloboSelectedItemsWrapper();

  const bodyObserver = new MutationObserver(initGloboSelectedItemsWrapper);

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/***** Sticky CTA Preis mit Hauptpreis synchronisieren *****/

(function () {
  function getMainPrice() {
    return (
      document.querySelector('[id^="price-"] .price-item--sale.price-item--last') ||
      document.querySelector('[id^="price-"] .price-item--regular') ||
      document.querySelector('[id^="price-"] .price-item')
    );
  }

  function syncStickyCtaPrice() {
    const mainPrice = getMainPrice();
    const stickyPrice = document.querySelector('.sticky-cta__price');

    if (!mainPrice || !stickyPrice) return;

    const priceText = mainPrice.textContent.trim();

    if (priceText) {
      stickyPrice.textContent = priceText;
    }
  }

  document.addEventListener('DOMContentLoaded', syncStickyCtaPrice);

  document.addEventListener('variant-change', () => {
    setTimeout(syncStickyCtaPrice, 50);
  });

  document.addEventListener('product-info:loaded', () => {
    setTimeout(syncStickyCtaPrice, 50);
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      setTimeout(syncStickyCtaPrice, 150);
    }
  });
})();

// Megamenü: kurze Hover-Unterbrechungen abfangen.
(() => {
  document.addEventListener('mouseleave', (event) => {
    const menu = event.target;

    if (!(menu instanceof Element)) return;
    if (!menu.matches('.header__inline-menu header-menu')) return;

    if (
      event.relatedTarget instanceof Node &&
      menu.contains(event.relatedTarget)
    ) {
      event.stopImmediatePropagation();
    }
  }, true);
})();